module.exports = __webpack_public_path__ + "img/caballito.f9fdd26d.png";